var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fu-filter-option",class:{'is-selected': _vm.selected, 'is-disabled': _vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_vm._v(" "+_vm._s(_vm.label || _vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }